document.addEventListener( 'DOMContentLoaded', function ( event ) {
	document.querySelectorAll('.products-nav').forEach( ( productsNav ) => {
		const openNavButton = productsNav.querySelector('.products-nav__toggle--open');
		const closeNavButton = productsNav.querySelector('.products-nav__toggle--close');

		openNavButton.addEventListener( 'click', function( e ) {
			e.preventDefault();
			productsNav.classList.add( 'open' );
		} );

		closeNavButton.addEventListener( 'click', function( e ) {
			e.preventDefault();
			productsNav.classList.remove( 'open' );
		} );

		const mainNavItems = productsNav.querySelectorAll('.products-nav__menu > li');
		mainNavItems.forEach( ( navItem ) => {
			const subNavTrigger = navItem.querySelector('.products-nav__item-container');
			if ( subNavTrigger ) {
				subNavTrigger.addEventListener( 'click', function() {
					if ( window.innerWidth < 767 || ( window.innerWidth >= 768 && window.innerHeight < 900 ) ) {
						if ( navItem.classList.contains( 'hover' ) || navItem.classList.contains( 'active' ) ) {
							navItem.classList.remove( 'hover' );
						} else {
							navItem.classList.add( 'hover' );
						}
						navItem.classList.remove( 'active' );
					} else {
						mainNavItems.forEach( ( item ) => item.classList.remove( 'hover' ) );
						navItem.classList.add( 'hover' );
					}
				} )
			}
		} );
	} );
}, { once: true } );
